const AUTH_TOKEN_STORAGE_KEY = 'ctms_access_token';

type AuthTokenListener = (token: string | null) => void;
const listeners = new Set<AuthTokenListener>();

let memoryToken: string | null = null;

function notifyListeners(token: string | null): void {
  for (const listener of listeners) {
    try {
      listener(token);
    } catch {
      // Ignore listener error
    }
  }
}

/**
 * Retrieve the active access token from storage.
 */
export function getAuthToken(): string | null {
  if (typeof window === 'undefined' || !window.localStorage) {
    return memoryToken;
  }
  try {
    return window.localStorage.getItem(AUTH_TOKEN_STORAGE_KEY) ?? memoryToken;
  } catch {
    return memoryToken;
  }
}

/**
 * Persist or clear the active access token.
 */
export function setAuthToken(token: string | null): void {
  memoryToken = token;
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      if (token) {
        window.localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
      } else {
        window.localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
      }
    } catch {
      // Storage unavailable or quota exceeded
    }
  }
  notifyListeners(token);
}

/**
 * Clear the active access token (e.g. on logout or 401).
 */
export function clearAuthToken(): void {
  setAuthToken(null);
}

/**
 * Subscribe to token changes (login, logout, session expiration).
 */
export function subscribeAuthToken(listener: AuthTokenListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
